import addwebhookpage from './add';
import webhookList from './list';

const translations = {
  ...addwebhookpage,
  ...webhookList,
};

export default translations;
